const withInstall = (options) => {
  options.install = (app) => {
    const { name } = options;
    if (name) {
      app.component(name, options);
    }
  };
  return options;
};
export {
  withInstall
};
